import { ConnectedCalendar } from '@modules/account/defs/types';
import { AvailableSlot } from '@modules/therapists/defs/types';

export interface AuthProvider {
  id: number;
  userId: number;
  provider: string;
  providerId: string;
  providerEmail: string;
  avatarUrl: string;
  isPrimary: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Zip {
  id: number;
  cityId: number;
  code: string;
  latitude: number;
  longitude: number;
}
export enum OnboardingStepEnum {
  WELCOME_VIDEO = 'welcome_video',
  CONFIGURE_WEEKLY_OPENING_TIMES = 'configure_weekly_opening_times',
  CONNECT_CALENDARS = 'connect_calendars',
  RECONNECT_CALENDARS = 'reconnect_calendars',
  COMPLETED = 'completed',
}
export interface Payment {
  id: number;
  userId: number;
  amount: number;
  amountWithTaxes: number;
  status: string;
  stripeChargeId?: string;
  failureReason?: string;
  label?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BillingProfile {
  id: number;
  userId: number;
  stripeId?: string;
  pmType?: string;
  pmLastFour?: string;
  cardBrand?: string;
  cardExpMonth?: number;
  cardExpYear?: number;
  vatNumber?: string;
  siret?: string;
  paymentFailedAt?: string;
  lastPaymentMethodAt?: string;
}

export interface Invoice {
  id: string;
  number?: string;
  amountDue: number;
  amountPaid: number;
  currency: string;
  status: string;
  description?: string;
  periodStart: number;
  periodEnd: number;
  created: number;
  invoicePdf?: string;
  hostedInvoiceUrl?: string;
}

export interface User {
  id: number;
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
  address: string;
  zipId: number;
  zip: Zip;
  city: string;
  country: string;
  departmentName?: string;
  latitude?: number;
  longitude?: number;
  duration: number;
  price: number;
  avatar: string;
  registrationStep: string;
  onboardingStep: OnboardingStepEnum;
  connectedCalendars: ConnectedCalendar[];
  isOnboardingCompleted: boolean;
  onboardingConversionFiredAt: string | null;
  isRegistrationCompleted: boolean;
  welcomeVideoCompleted: boolean;
  welcomeVideoCompletedAt: string;
  hasClaimedLead: boolean;
  isBookable: boolean;
  isBanned: boolean;
  emailVerifiedAt: string;
  regionName?: string;
  // Flag BO : l'espace prospect du praticien est-il fermé (région × audience) ? (cf /auth/me)
  isProspectSpaceClosed?: boolean;
  userableId: number;
  tokens: number;
  status: string;
  lastLoginAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  role: string;
  permissions: string[];
  rolesNames: string[];
  permissionsNames: string[];
  fullName: string;
  providers: AuthProvider[];
  availableSlots?: AvailableSlot[];
  delayBetweenAppointments: number;
  metadata?: {
    reviews?: { author: string; text: string }[];
    [key: string]: unknown;
  } | null;

  activeSubscriptions: Array<{
    key: string;
    name: string;
    startsAt: string;
    endsAt: string | null;
    priceCents: number;
    interval: string | null;
  }>;

  subscriptions?: Array<{
    id: number;
    subscription: { key: string; label: string };
    starts_at: string;
    ends_at: string | null;
  }>;

  // Billing & Subscription fields
  hasPaymentMethod?: boolean;
  pmType?: string;
  pmLastFour?: string;
  cardBrand?: string;
  payments?: Payment[];
  billingProfile?: BillingProfile;

  // SystemX subscription fields
  adsetId?: string;
  campaignsIds?: string[];
  dailyBudget?: number;
  dailyBudgetWithTaxes?: number;
  balance?: number;
  balanceWithTaxes?: number;
  threshold?: number;
  hasActiveSx?: boolean;
  isDemo?: boolean;
  hasSystemxHistory?: boolean;
  hasRecurrentCosts?: boolean;
  banReason?: string;
  paymentFailedAt?: string;
  shouldPayBalance?: boolean;
  stripeId?: string;
  vatNumber?: string | null;
  isActive?: boolean;
  accessCode?: string;
}

export interface UserFormInput {
  name: string;
  email: string;
  password: string;
}
